import { ISlot } from '../../organisms/bo_calendar_slot/types';

type SlotStartTimes = Pick<ISlot, 'overallStartTime' | 'startTime'>;
type SlotEndTimes = Pick<ISlot, 'overallEndTime' | 'endTime'>;

/**
 * Chronological start for sort/layout: overall window when set, else base startTime.
 */
export function getEffectiveStartTime(slot: SlotStartTimes): string {
	return slot.overallStartTime ?? slot.startTime;
}

/**
 * Chronological end for sort/layout: overall window when set, else base endTime.
 */
export function getEffectiveEndTime(slot: SlotEndTimes): string {
	return slot.overallEndTime ?? slot.endTime;
}
